import { Search, X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SearchBarProps {
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
  className?: string;
}

export function SearchBar({
  value,
  onChange,
  placeholder = 'Search flavor or SKU…',
  className,
}: SearchBarProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-2 px-3.5 py-2.5 rounded-xl border bg-brix-surface',
        'border-brix-border transition-all duration-200',
        'focus-within:border-brix-primary focus-within:ring-2 focus-within:ring-brix-primary/20',
        className,
      )}
    >
      <Search size={16} className="text-brix-muted shrink-0" />
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        type="search"
        className="bg-transparent outline-none text-sm flex-1 text-brix-ink placeholder:text-brix-muted"
        aria-label="Search catalog"
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          className="text-xs text-brix-muted hover:text-brix-ink transition-colors duration-200 cursor-pointer flex items-center gap-1"
          aria-label="Clear search"
        >
          <X size={12} />
          Clear
        </button>
      )}
    </div>
  );
}
